const constants = require('@/util/constants')
require('./config')

/**
 * 设置客服接待状态
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function setAcceptStatus (status, successcb, failedcb) {
    axios.post('/api/status/set', {
        status,
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 设置视频客服接待状态
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function setWebrtcStatus(status, successcb, failedcb) {
    axios.post('/api/status/webrtc/set', {
        status,
        client: constants.HTTP_CLIENT
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 获取历史在线状态
 */
export function getHistoryStatus (page, size, successcb, failedcb) {
    axios.get('/api/status/request', {
        params: {
        'page': page,
        'size': size,
        'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 搜索过滤在线状态
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterStatus (page, size, createdAtStart, createdAtEnd,
    agentRealName, client, successcb, failedcb) {
    axios.get('/api/status/filter', {
        params: {
        'page': page,
        'size': size,
        'createdAtStart': createdAtStart,
        'createdAtEnd': createdAtEnd,
        'agentRealName': agentRealName,
        'client': client
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
